// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1Ku9ZtY4","spinner":"_1TdEQlr8","ring":"_31-DAU64"};